
import { Component, Vue } from 'vue-property-decorator';
import OnboardingWelcome from '@/components/onboarding/OnboardingWelcome.vue';
import OnboardingAuthenticator from '@/components/onboarding/OnboardingAuthenticator.vue';
import OnboardingNoMFA from '@/components/onboarding/OnboardingNoMFA.vue';
import OnboardingFinished from '@/components/onboarding/OnboardingFinished.vue';
import OnboardingSms from '@/components/onboarding/OnboardingSms.vue';

@Component({
  components: {
    OnboardingSms,
    OnboardingNoMFA,
    OnboardingFinished,
    OnboardingAuthenticator,
    OnboardingWelcome,
  },
})
export default class Onboarding extends Vue {
  MFATypes = ['sms', 'authenticator', 'none'];

  MFAType = '';

  finished = false;

  isActiveType(type: string): boolean {
    return type === this.MFAType;
  }

  chooseMFAType(type: string) {
    this.MFAType = type;
  }

  get MFATypeSteps(): string[] {
    if (this.$te(`onboarding.${this.MFAType}.steps`)) {
      return this.$t(`onboarding.${this.MFAType}.steps`).toString().split('|');
    }
    return [];
  }

  setFinished() {
    this.finished = true;
  }
}
